(function (t) {
// fr
t.add("Next", "Suivant", "pagination", "fr");
t.add("Previous", "Pr\u00e9c\u00e9dent", "pagination", "fr");
t.add("\u00ab", "\u00ab", "pagination", "fr");
t.add("\u00bb", "\u00bb", "pagination", "fr");
})(Translator);
